// «Ren UX» fakta-linje for plass-kortet: samler plassens egne amenities (vann, bål, vei,
// bilder) til ÉN rolig, prikk-separert linje i stedet for løsrevne badges. Absorberer bl.a.
// vann-signalet som markøren mister i calm-modus. Ren utvelgelse (HVILKE fakta) her —
// selve ikon/label-renderingen bor i kortet (SpotCard), som har `t`.

export type SpotFactKind = 'water' | 'firepit' | 'road' | 'photo';

export interface SpotFact {
  kind: SpotFactKind;
  /** Meter (water), etikett (road) eller antall (photo). Udefinert for rene flagg (firepit). */
  value?: number | string;
}

export interface SpotFactInput {
  /** Avstand til nærmeste vann i meter. Vises kun innenfor terskelen (amenity-lokke, ikke geografi). */
  nearestWaterM?: number | null;
  isFirepit?: boolean;
  /** Ferdig etikett fra kortets vei-tag (roadTypeTag), eller null/tom om ukjent. */
  roadLabel?: string | null;
  photoCount?: number;
}

// Vann teller som «fasilitet ved plassen» kun når det er rimelig nært; lenger unna er det
// geografi, ikke et salgsargument. Samme ånd som markørens 100 m-vann-badge, litt romsligere.
export const WATER_FACT_MAX_M = 500;

/** Velger hvilke fakta fakta-linjen skal vise, i fast rekkefølge: vann → bål → vei → bilder. */
export function selectSpotFacts(input: SpotFactInput): SpotFact[] {
  const facts: SpotFact[] = [];
  if (typeof input.nearestWaterM === 'number' && input.nearestWaterM >= 0 && input.nearestWaterM <= WATER_FACT_MAX_M) {
    facts.push({ kind: 'water', value: input.nearestWaterM });
  }
  if (input.isFirepit) facts.push({ kind: 'firepit' });
  const roadLabel = typeof input.roadLabel === 'string' ? input.roadLabel.trim() : '';
  if (roadLabel) facts.push({ kind: 'road', value: roadLabel });
  if (typeof input.photoCount === 'number' && input.photoCount > 0) {
    facts.push({ kind: 'photo', value: input.photoCount });
  }
  return facts;
}
